import { ICustomerData, AdvanceSearchFormType } from 'pages/customer/type';

export const types = {
  SET_CUSTOMER_LIST: 'SET_CUSTOMER_LIST' as const,
  SAVE_ADVANCED_SEARCH_SETTINGS: 'SAVE_ADVANCED_SEARCH_SETTINGS' as const,
};

export const setCustomerList = (list: ICustomerData[], isListFromAdvancedSearch: boolean = false) => ({
  type: types.SET_CUSTOMER_LIST,
  payload: { list, isListFromAdvancedSearch },
});

export const saveAdvancedSearchSettings = (payload: AdvanceSearchFormType) => ({
  type: types.SAVE_ADVANCED_SEARCH_SETTINGS,
  payload,
});

export type Actions = (
  | ReturnType<typeof setCustomerList>
  | ReturnType<typeof saveAdvancedSearchSettings>
);
